import { Method } from 'axios';
import { Executable } from './executable';

/**
 * Delete a wallet by passId or email and programId.
 */
export class DeleteWallet extends Executable<boolean> {
  public brandId?: number;

  public programId?: number;

  public email?: string;

  public passId?: number;

  public getMethod(): Method {
    return 'delete';
  }

  public getResponse(apiResponse: any): boolean {
    return apiResponse;
  }

  // @ts-ignore-no-usused-vars
  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (this.passId) {
      return `${this.brandId}/wallets/${this.passId}?hard_delete=true`;
    }
    if (this.email && this.programId) {
      return `${this.brandId}/programs/${
        this.programId
      }/wallets?hard_delete=true&email=${encodeURIComponent(this.email)}`;
    }
    throw new Error('Either passId or email and programId are required');
  }

  constructor(brandId: number, passId?: number, programId?: number, email?: string) {
    super();
    this.brandId = brandId;
    this.passId = passId;
    this.programId = programId;
    this.email = email;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
